module.exports = __webpack_public_path__ + "static/media/search.63e93bfe.png";